import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Country, OccSiteAdapter, TranslatePipe } from '@spartacus/core';
import { Observable } from 'rxjs';
import { WIDGET_PAGESIZE } from 'src/constants/pagination.constant';

import { KnBrCustomerService } from '../../../store/kn-br-customer/kn-br-customer.service';
// import { KnBrContactService } from 'src/app/services/kn-br-contact.service';
import { tap } from 'rxjs/operators';
import { NgSelectComponent } from '@ng-select/ng-select';
import { PageSlotComponent } from '@spartacus/storefront';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'knbr-customer-header',
    templateUrl: './kn-br-customer-header.component.html',
    styleUrls: ['./kn-br-customer-header.component.scss'],
    providers: [OccSiteAdapter],
    imports: [ReactiveFormsModule, NgSelectComponent, PageSlotComponent, AsyncPipe, TranslatePipe]
})
export class KnBrCustomerHeaderComponent implements OnInit {
  isCountryLoading = false;
  isRegionLoading = false;
  customerSearchForm: FormGroup;
  isSearchDisabled$: Observable<boolean> = this.customerSearchService.searchDisabled$;
  currentPage = 0;
  usaCanadaMexicoCountryList: any[];
  stateList: any[];
  objectKeys = Object.keys;
  defaultedCountry = '';

  constructor(
    private occSiteAdapter: OccSiteAdapter,
    private fb: FormBuilder,
    private customerSearchService: KnBrCustomerService,
    // private knBrContactService: KnBrContactService
  ) {}

  ngOnInit(): void {
    this.getCountries();
    this.initForm();
    this.submitForm();
  }

  initForm() {
    this.customerSearchForm = this.fb.group({
      customerName: null,
      customerNumber: null,
      countryCode: null,
      stateCode: null,
      city: null,
      postalCode: null,
      currentPage: this.currentPage,
      pageSize: WIDGET_PAGESIZE,
    });
  }

  getCountries() {
    this.isCountryLoading = true;
    this.occSiteAdapter.loadCountries().subscribe(res => {
      this.usaCanadaMexicoCountryList = res.filter(
        eachItem => ['US', 'MX', 'CA'].includes(eachItem.isocode)
      );
      this.isCountryLoading = false;
      const currency = localStorage.getItem('spartacus⚿⚿currency');
      const cleanedCurrency = currency?.replace(/['"]+/g, '');
      const countryIso = cleanedCurrency === 'CAD' ? 'CA' : cleanedCurrency === 'USD' ? 'US' : 'MX';
      this.defaultedCountry = countryIso;
      this.countrySelected({ isocode: countryIso } as Country)
    })
  }

  countrySelected(country: Country) {
    if (country && country.isocode) {
      this.customerSearchForm.patchValue({
        stateCode: null,
      });
      this.occSiteAdapter.loadRegions(country.isocode).pipe(tap(() => (this.isRegionLoading = false))).subscribe(res => {
        if (res) {
          if (country && country.isocode) {
            this.stateList = res.filter(eachItem => eachItem.isocode.startsWith(country.isocode));
          }
        }
      })
    } else if (!country) {
      this.stateList = [];
      this.customerSearchForm.controls.stateCode.setValue(null);
    }
  }

  submitForm() {
    this.customerSearchService.search(this.customerSearchForm.value);
  }

  resetForm() {
    this.customerSearchForm.reset();
    this.currentPage = 0;
    this.customerSearchForm.patchValue({
      currentPage: this.currentPage,
      pageSize: WIDGET_PAGESIZE,
    });
    this.submitForm();
  }
}
